import { IRateCard } from "@wingspanhq/payments/dist/interfaces";
import { servicePayments } from "../servicePayments";

export const getRateCard = async (rateCardId: string): Promise<IRateCard> => {
  const response = await servicePayments.get(`/rate-card/${rateCardId}`);
  return response.data;
};
